// src/utils/geocode.ts
export type LatLng = [number, number];

/**
 * Given an array of postcodes, returns a map { postcode → [lat, lng] }.
 * Uses postcodes.io batch endpoint (max 100 per request).
 */
export async function geocodePostcodes(
  postcodes: string[]
): Promise<Record<string, LatLng>> {
    const chunks: string[][] = [];
    for (let i = 0; i < postcodes.length; i += 100) {
        chunks.push(postcodes.slice(i, i + 100));
    }

    const result: Record<string, LatLng> = {};
    await Promise.all(
        chunks.map(async (pcs) => {
            const res = await fetch("https://api.postcodes.io/postcodes", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ postcodes: pcs }),
            });
            const body = await res.json();
            console.log("res", body);
            if (body.status === 200 && Array.isArray(body.result)) {
                body.result.forEach((r: any) => {
                    if (r.result) {
                        result[r.query] = [r.result.latitude, r.result.longitude];
                    }
                });
            }
        })
    );


    return result;
}
